export default async () => {
  const entries = document.querySelectorAll('.js-dln-hotspot');
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "HotSpotComponentController-lib" */ '@/utils/Controllers/HotSpot/HotSpotComponentController'
    );
    controller.default();
  }
};
